
























import { defineComponent, type PropType } from "vue-demi";
import GGProductSliderCard from "./GGProductSliderCard.vue";
import type {
  PageDataPropUnion,
  Product,
} from "@constructor/shared-entity/type";
import getValueForProp from "../../helper/getValueForProp";

export default defineComponent({
  name: "GGProductSliderGrid",
  components: {
    GGProductSliderCard,
  },
  props: {
    list: {
      type: Array as PropType<Product[]>,
      required: true,
    },
    data: {
      type: Array as PropType<PageDataPropUnion[]>,
      default: () => [],
    },
    size: {
      type: String as PropType<string>,
      default: "wide",
      validator(el) {
        return ["shrink", "wide"].some((item) => item === el);
      },
    },
  },
  computed: {
    promocode() {
      return getValueForProp("sliderCardPromocode", this.data) || undefined;
    },
    promocodeColor() {
      return (
        getValueForProp("sliderCardPromocodeColor", this.data) || undefined
      );
    },
    label() {
      return getValueForProp("sliderCardLabel", this.data) || undefined;
    },
    sliderGridItems() {
      const itemsCount = this.size === "wide" ? 7 : 6;
      const sliderItems = this.list.slice(0, this.list.length - itemsCount);
      const gridItems = this.list.slice(-itemsCount);

      return [sliderItems, gridItems];
    },
  },
});
